import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import FileConstants from '../../../../FileConstants';
import '@ant-design/compatible/assets/index.css';
import _ from 'lodash'; // Import the entire lodash library
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Tabs, Button } from 'antd';
import RoomsListVirtualized from './RoomsListVirtualized';
import Filters from './Filters';
import DottedLoader from '../../DottedLoader';
import { CheckCircleFilled, CheckOutlined, LoadingOutlined } from '@ant-design/icons';

const SelectSpace = (props) => {
  const COMPANY_ID = FileConstants.COMPANY_ID;
  const SHARED_ENTITIES = FileConstants.SHARED_ENTITIES;
  const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;
  const MANAGED_COMPANY_ID = FileConstants.MANAGED_COMPANY_ID;
  const [ownedSpaceData, setOwnedSpaceData] = useState([]);
  const [sharedSpaceData, setSharedSpaceData] = useState([]);
  const [storeSpaceData, setStoreSpaceData] = useState([]);
  const [mspUserData, setMspUserData] = useState([]);
  const [tabActiveKey, setTabActiveKey] = useState('owned');
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isMSProvider, setIsMSProvider] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [dataLoading, setDataLoading] = useState(false);
  const { selectedRoom, setSelectedRoom, setStep, setLoading, setIsStore, isStore,loading, empty_scene, creationType, requestStatusRoom} = props;
  const [mspFilteredData, setMspFilteredData] = useState([]);
  const [ownedFilteredData, setOwnedFilteredData] = useState([]);
  const [sharedFilteredData, setSharedFilteredData] = useState([]);
  const [storeFilteredData, setStoreFilteredData] = useState([]);
  const [storeSpacesLoader, setStoreSpacesLoader] = useState(true);
  const [initialLoadSpaces, setInitialLoadSpaces] = useState(false);
  const [initialLoadShared, setInitialLoadShared] = useState(true);
  const [initialLoadOwned, setInitialLoadOwned] = useState(true);
  const [sharedSpaceLoader, setSharedSpaceLoader] = useState(true);
  const [ownedSpaceLoader, setOwnedSpaceLoader] = useState(true);  

  const tabs = [
    {
      type: 'msp',
      title: `${localStorage.getItem('managed_customer_username')}'s spaces (${mspFilteredData.length})`,
      data: mspUserData,
      setData: setMspFilteredData,
    },
    {
      type: 'owned',
      title: `Your Spaces ${ownedSpaceLoader ? '' : `(${ownedFilteredData.length})`}`,
      data: ownedSpaceData,
      setData: setOwnedFilteredData
    },
    {
      type: 'other',
      title: `Other Spaces ${sharedSpaceLoader ? '' : `(${sharedFilteredData.length})`}`,
      data: sharedSpaceData,
      setData: setSharedFilteredData
    },
    {
      type: 'store',
      title: `Store Spaces ${storeSpacesLoader ? `` : `(${storeFilteredData.length})`}`,
      data: storeSpaceData,
      setData: setStoreFilteredData
    },
  ];
  const { TabPane } = Tabs;

  const getRoomPayload = (initial, type, sequence_id) => {
    const payload = {
      'required_fields': ['room_id', 'room_name', 'brand_id', 'category', 'dimensions',
        'customer_username', 'model_status', 'thumbnail', 'last_modified_stamp', 'variant_of',
        'is_store_item', 'company_id', 'style', 'platform', 'tags', 'price', 'space_areas'],
    };
    if (FileConstants.isMSProvider) {
      payload['order_by'] = 'last_modified_stamp desc';
    } else {
      if (sequence_id != -1) {
        payload['required_fields'].push('folder_id', 'folder_name', 'parent_folder_id',
            'library_order', 'entity_order');
        payload['order_by'] = 'library_order asc,entity_order asc';
      } else {
        payload['order_by'] = 'last_modified_stamp desc';
      }
    }
    let filter_string = '';
    let shared_username = '';
    const customer_username = 'customer_username__exact=\'' + CUSTOMER_USERNAME + '\'';
    const customer_username_notexact = 'customer_username__notexact=\'' + CUSTOMER_USERNAME + '\'';
    let company_id_notexact = '';

    let company_id = '';
    const model_status = 'model_status__in=[5]';
    const is_hidden = 'is_hidden__not=true';
    const shared_hidden = 'shared_hidden__not=true';
    const sequence_id_value = 'sequence_id__exact='+sequence_id;
    if (type == 'shared') {
      payload['required_fields'].push('shared_username');
      payload['required_fields'].push('shared_room_type');
      shared_username = 'shared_username__exact=\'' + CUSTOMER_USERNAME + '\'';
      filter_string = '('+shared_username + '&&' + shared_hidden + ')';

      if (SHARED_ENTITIES != undefined && COMPANY_ID && SHARED_ENTITIES.split('_').includes('room')) {
        company_id_notexact = 'company_id__notexact=' + COMPANY_ID + '||company_id__isnull=true';
        filter_string = filter_string + '&&(' + company_id_notexact + ')&&('+customer_username_notexact+')';
      } else {
        filter_string = filter_string + '&&('+customer_username_notexact+')';
      }
    } else if (SHARED_ENTITIES != undefined && COMPANY_ID && SHARED_ENTITIES.split('_').includes('room')) {
      company_id = 'company_id__exact=' + COMPANY_ID;
      filter_string = '('+company_id+'||'+customer_username+')&&(' + is_hidden + ')';
    } else {
      if (FileConstants.isMSProvider) {
        company_id = 'company_id__isnull=true';
        const requested_for = 'requested_for__isnull=true';
        filter_string = '('+company_id+'&&'+customer_username+')&&(' + is_hidden + ')&&(' + requested_for + ')';
      } else {
        filter_string = '('+customer_username+ '&&' + is_hidden +')';
      }
    }
    filter_string = filter_string + '&&(' + model_status + ')';
    if (sequence_id != -1) {
      filter_string = filter_string + '&&(' + sequence_id_value + '||sequence_id__isnull=true)';
    }
    payload['filter_string'] = filter_string;
    if (initial) {
      payload['pagination_filters'] = {
        'limit': 100,
        'offset': 0,
      };
    }
    return payload;
  };

  const fetchRoomData = async (type, sequenceId, initial = false) => {
    if (!initial) {
        setDataLoading(true);
      } else {
        if (type == 'shared') {
          setInitialLoadShared(true);
        } else {
          setInitialLoadOwned(true);
        }
    }
    const payload = getRoomPayload(initial, type, sequenceId);
    const data = [];
    await axios.post(ENVIRONMENT.LIST_ROOMS, payload)
        .then((res) => {
          if (res.data) {
            const dataWithKeywords = getRoomsDataWithKeywords(res.data);
            type === 'owned' && setOwnedSpaceData(dataWithKeywords);
            type === 'shared' && setSharedSpaceData(dataWithKeywords);
          }

          if (initial) {
            if (type == 'shared') {
              setInitialLoadShared(false);
            } else {
              setInitialLoadOwned(false);
            }
          } else {
            if (type == 'shared') {
              setSharedSpaceLoader(false);
            } else {
              setOwnedSpaceLoader(false);
            }
          }
        });
    return data;
  };

  const fetchSpaceCategories = () => {
    const payload = {
      'request_type': 'room_model',
    };
    axios.post(ENVIRONMENT.GET_CATEGORY_AND_PRICE, payload)
        .then((res) => {
          let categories = [];
          if (res.data) {
            res.data.map((request) => {
              if (!categories.includes(request.category)) {
                categories.push(request.category);
              }
            });
            categories = categories.filter((item) => item !== '');
            setCategories(categories);
          }
        });
  };

  const fetchStoreRoomData = async (initial = false) => {
    const data = [];
    setStoreSpacesLoader(true);
    let payload = {
      item_type: 'room',
      username: localStorage.getItem('username')
    }
    if (initial) {
      payload.limit = '';
      setInitialLoadSpaces(true);
    }
    axios.post(ENVIRONMENT.STORE_LIST, payload)
        .then((res) => {
          if (!initial) {
            setStoreSpacesLoader(false);
          }
          const dataWithKeywords = getRoomsDataWithKeywords(res.data);
          setStoreSpaceData(dataWithKeywords);
        })
        .catch((error) => {
        });
    return data;
  };

  const getRoomsDataWithKeywords = (rooms) => {
    const result = rooms.map((obj) => {
      let keywords = [];

      for (const keyword of obj.room_name.replace(/[^a-zA-Z0-9 ]/g, ' ').split(' ')) {
        if (!keywords.includes(keyword)) {
          if (keyword.length > 1) {
            keywords.push(keyword.toLowerCase());
          }
        }
      }

      for (const keyword of obj.category.replace(/[^a-zA-Z0-9 ]/g, ' ').split(' ')) {
        if (!keywords.includes(keyword)) {
          if (keyword.length > 1) {
            keywords.push(keyword.toLowerCase());
          }
        }
      }

      if (obj?.style && obj.style != '') {
        keywords.push(obj.style.toLowerCase());
      }

      for (const keyword of obj.tags.split(', ')) {
        if (!keywords.includes(keyword)) {
          if (keyword.length > 1) {
            keywords = keywords.concat(keyword.toLowerCase().split(' '));
          }
        }
      }

      if (obj.folder_name) {
        keywords = keywords.concat(obj.folder_name.toLowerCase().split(' '));
      }

      return { ...obj, 'keywords': keywords };
    });
    return result;
  };

  const getMSPRoomPayload = () => {
    const payload = {
      'required_fields': ['room_id', 'room_name', 'brand_id', 'category', 'customer_username',
        'model_status', 'thumbnail', 'last_modified_stamp', 'variant_of',
        'is_store_item', 'dimensions', 'company_id', 'is_shared', 'platform', 'tags', 'space_areas'],
    };
    payload['order_by'] = 'is_shared desc, last_modified_stamp desc';
    let filterString = '';
    const customer_username = 'customer_username__exact=\'' + localStorage.getItem('managed_customer_username') + '\'';
    let company_id = '';
    const model_status = 'model_status__in=[5]';
    const is_hidden = 'is_hidden__not=true';
    const has_access_to = 'has_access_to__like=\'%"' + localStorage.getItem('managed_customer_username') + '"%\'';

    if (MANAGED_COMPANY_ID) {
      company_id = 'company_id__exact=' + parseInt(MANAGED_COMPANY_ID);
      filterString = '(' + company_id + '||' + customer_username + ')&&(' + is_hidden + ')';
    } else {
      filterString = '(' + customer_username + '&&' + is_hidden + ')';
    }
    filterString = filterString + '&&(' + model_status + ')' + '||(' + has_access_to + ')';

    payload['filter_string'] = filterString;

    return payload;
  };

  const getCustomerDataForMsprovider = async () => {
    const payload = getMSPRoomPayload();
    await axios.post(ENVIRONMENT.LIST_ROOMS, payload)
        .then((res) => {
          if (res.data) {
            const data = getRoomsDataWithKeywords(res.data);
            setMspUserData(data);
          }
        });
  };

  const handleTabChange = (key) => {
    setTabActiveKey(key);
    if (key == 'store') {
      setIsStore(true);
    } else setIsStore(false);
  };

  const handleContinue = () => {
    if (empty_scene) {
      setStep(4); // product selection
    } else {
      setStep(3);
    }
    
  };

  useEffect(() => {
    const fetchData = async () => {
      fetchSpaceCategories();
      fetchRoomData('owned', -1, true);
      fetchRoomData('shared', -1, true);
      await fetchStoreRoomData(true);
      if ( FileConstants.isMSProvider &&
        (localStorage.getItem('managed_customer_username') != null || MANAGED_COMPANY_ID != null)) {
        await getCustomerDataForMsprovider();
        setIsMSProvider(true);
      }
      setDataLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (initialLoadSpaces) {
      fetchStoreRoomData();
    }
  }, [initialLoadSpaces]);

  useEffect(() => {
    if (!initialLoadOwned && ownedSpaceLoader) {
        fetchRoomData('owned', -1);
    }
  }, [initialLoadOwned]);

  useEffect(() => {
    if (!initialLoadShared && sharedSpaceLoader) {
        fetchRoomData('shared', -1);
    }
  }, [initialLoadShared]);

  useEffect(() => {
    setMspFilteredData(mspUserData);
    setOwnedFilteredData(ownedSpaceData);
    setSharedFilteredData(sharedSpaceData);
    setStoreFilteredData(storeSpaceData);
    setIsStore(false)
  }, [mspUserData, ownedSpaceData, sharedSpaceData, storeSpaceData]);

  const goBack = () => {
    window.location.href = '/my_scenes'
  }

  return (
    <div className="spaces-list">
      <Filters
        handleValueChange = { setSelectedCategories }
        selectedValue = {selectedCategories}
        filters = { categories }
        searchValue = { searchValue }
        setSearchValue = { setSearchValue }
        title = 'Select a space for your scene'
        searchPlaceholder = 'Search all spaces'
      />
      <Tabs
        onChange={(key) => handleTabChange(key)}
        className="product-tab library"
        tabBarGutter={16}
        size="large"
        activeKey={tabActiveKey}
      >
        {initialLoadOwned || initialLoadShared ? (
          <DottedLoader />
        ) : (
        tabs?.map((tab, index)=>{
          return (
            index === 0 && !isMSProvider ? null :
            <TabPane
              tab= {tab.title}
              key={tab.type}
            >
              <RoomsListVirtualized
                type = 'space'
                roomsData={tab.data}
                selectedRoom = { selectedRoom }
                setSelectedRoom = { setSelectedRoom }
                searchValue = { searchValue }
                selectedCategories = { selectedCategories }
                setSelectedCategories = { setSelectedCategories }
                setData = { tab.setData }
                creationType = {creationType}
                isStore = {isStore}
                requestStatusRoom = {requestStatusRoom} 
              />
            </TabPane>
          );
        }))}
      </Tabs>
      <div className={`bottom-menu ${((!initialLoadOwned && ownedSpaceLoader && tabActiveKey == "owned") || (sharedSpaceLoader && tabActiveKey == "other") || (storeSpacesLoader && tabActiveKey == "store")) ?  'justify-space-between-important' : ``} `}>
          {((!initialLoadOwned && ownedSpaceLoader && tabActiveKey == "owned") || (sharedSpaceLoader && tabActiveKey == "other") || (storeSpacesLoader && tabActiveKey == "store")) &&
            <div className='manrope f-16 justify-in-start ml-100' style={{color:'#276DD7', padding:10}}>
                <LoadingOutlined className='manrope f-24 mr-16' />
                Loading remaining {tabActiveKey} spaces
            </div>}
            <div className='mr-20 justify-in-end'>
              <Button
                  onClick={props.handleCancel}
                  className='product-btn br-4 f-16 light-blue pd-16'>
                      Back
                </Button>
                <Button
                  onClick={handleContinue}
                  disabled={selectedRoom == null}
                  className = {selectedRoom == null ? 'product-btn br-4 f-16 disabled-grey ml-16 pd-16' : 'product-btn dark-blue f-16 ml-16 br-4 pd-16'}>
                      Continue {loading ? <LoadingOutlined /> : ''}
                </Button>
            </div>
          </div>
    </div>
  );
};

const mapStateToProps = (state) => state;

export default withRouter(connect(
    mapStateToProps,
)(SelectSpace),
);
